import { Children, useEffect } from "react";

import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX, faSliders } from "@fortawesome/free-solid-svg-icons";

import TableRow from "./components/TableRow/";
import TableHeader from "./components/TableHeader";
import Pagination from "../../../../components/Pagination/";
import CustomButton from "../../../../components/CustomButton";

import "./index.scss";
import COLORS from "../../../../data/colors";
import { useTable } from "./hooks/useTable";
import useBreakpoint from "../../../../hooks/useBreakpoint";
import { useNavigate } from "react-router-dom";
import useUser from "../../../../hooks/useUser";
import { useLazyQuery } from "@apollo/client";

import { useTranslation } from "react-i18next";

export const replaceUnderscoreAndCamelCaseToString = (str) => {
  return str
    .replace(/([A-Z])/g, " $1")
    .replace(/([A-Z])/g, " $1")
    .replaceAll("_", " ")
    .toUpperCase();
}

const CustomTable = ({
  data,
  tableHead,
  page,
  setPage,
  type,
  expandFilters,
  setExpandFilters,
  filters,
  setFilters,
  sortBy,
  setSortBy,
  columnsPerFieldMap,
  rowClassName,
  headerClassName,
  hasFilters,
  hasPagination,
  pageLimit,
  totalCount,
  onClickHandlers = [],
  children,
  customTitle,
  onMouseDownHandlers
}) => {
  const [size] = useBreakpoint();
  const { t } = useTranslation();

  const initialState = {
    tableData: data,
    tableHeaders: tableHead,
    isMobile: size === "xs" || size === "sm" || size === "md",
    total: totalCount,
    filters: [],
    expandFilters: false,
  };

  const { state, setIsMobile } = useTable(initialState);
  const { tableData, tableHeaders, isMobile, total } = state;

  const handleExpand = (value) => {
    setExpandFilters(value);
  };

  useEffect(() => {
    window.addEventListener(
      "resize",
      () => {
        setIsMobile(size === "xs" || size === "sm" || size === "md");
      },
      false
    );
  }, [size, setIsMobile])

  const {user} = useUser()

  return (
    <div className="py-2">
      <div className="col-12 pt-0 pl-3 pr-0 mx-auto">
        <div className="mx-1 mx-xxl-5">
          {hasFilters && (
            <div
              className={`${
                isMobile ? "" : "d-flex justify-content-start mb-2"
              }`}
            >
              {!isMobile && (
                <div
                  className="table-title h6-style my-3"
                  style={{ marginRight: "2%" }}
                >
                  {total}
                </div>
              )}
              {isMobile && (
                <div className="d-flex">
                  <div
                    className="table-title h6-style my-3"
                    style={{ marginRight: "2%" }}
                  >
                    {total}
                  </div>
                </div>
              )}
              <div
                className={`my-3 ${isMobile ? "hide" : ""}`}
                style={{
                  marginRight: "2%",
                  border: "1px solid #DDDDDD",
                }}
              ></div>
              <div className="table-title active-filters my-3">
                <div className="d-flex align-items-center flex-wrap">
                  <div className="h6-style" style={{ marginRight: 5 }}>
                    {t('table.activeFilters')}
                  </div>
                </div>
              </div>
            </div>
          )}
          {tableData?.length !== 0 ? (
            <>
              <TableHeader
                labels={tableHeaders}
                isMobile={isMobile}
                fieldToHeader={replaceUnderscoreAndCamelCaseToString}
                columnsPerFieldMap={columnsPerFieldMap}
                className={`table-header ${
                  Children.count(children) !== 0 ? `${headerClassName}` : ``
                }`}
              />
              <>
                {tableData?.map((row, index) => {

                  return (
                    <TableRow
                      key={"row-id-" + (row.id || index)}
                      row={row}
                      labels={tableHeaders}
                      isMobile={isMobile}
                      fieldToHeader={replaceUnderscoreAndCamelCaseToString}
                      type={type}
                      columnsPerFieldMap={columnsPerFieldMap}
                      rowClassName={rowClassName}
                      className={`${
                        onClickHandlers.length > index
                          ? "table-row-with-on-click-handler"
                          : ""
                      }`}
                      onClickHandler={
                        onClickHandlers.length > index
                          ? onClickHandlers[index]
                          : undefined
                      }
                      onMouseDown={
                        onMouseDownHandlers?.length > index
                          ? onMouseDownHandlers[index]
                          : undefined
                      }
                    >
                      {Children.count(children) > index
                        ? children[index]
                        : null}
                    </TableRow>
                  );
                })}
                {hasPagination && (
                  <div className="d-flex justify-content-center">
                    <Pagination
                      total={total}
                      page={page}
                      pageLimit={pageLimit}
                      setPage={setPage}
                    />
                  </div>
                )}
              </>
            </>
          ) : (
            <div className="text-center mt-4">
              <i
                className="fa fa-frown-o fa-5x no-results"
                aria-hidden="true"
              ></i>
              <h5 className="text-center mt-2">
                {t('table.noResults')}
              </h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomTable;
